import React from 'react';
import CircledIconButton from 'Components/ComponentLibrary/Atoms/Inputs/CircledIconButton';
import theme from 'Theme';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const styles = {
  root: {},
  iconStyle: {
    width: '20px',
    height: '20px',
    fill: theme.palette.facet.primaryBlue,
  },
  iconButton: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  verticalCenter: {
    display: 'flex',
    alignItems: 'center',
  },
};

const PrioritySwitcher = ({
  className, classes, onRaisePriority, onLowerPriority,
}) => (
  <div className={classNames(className, classes.verticalCenter)}>
    {onRaisePriority && (
      <CircledIconButton
        className={classes.iconButton}
        onClick={onRaisePriority}
        backgroundColor={theme.palette.facet.accentBlue20}
        title="Raise Priority"
        test={'priority-switcher-raise-button'}
      >
        <ArrowDropUpIcon className={classes.iconStyle} />
      </CircledIconButton>
    )}
    {onLowerPriority && (
      <CircledIconButton
        className={classes.iconButton}
        onClick={onLowerPriority}
        backgroundColor={theme.palette.facet.accentBlue20}
        title="Lower Priority"
        test={'priority-switcher-lower-button'}
      >
        <ArrowDropDownIcon className={classes.iconStyle} />
      </CircledIconButton>
    )}
  </div>
);

PrioritySwitcher.defaultProps = {
  className: undefined,
  onRaisePriority: undefined,
  onLowerPriority: undefined,
};

PrioritySwitcher.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onRaisePriority: PropTypes.func,
  onLowerPriority: PropTypes.func,
};

export default withStyles(styles)(PrioritySwitcher);
